import { render, staticRenderFns } from "./TablePOChangeOld.vue?vue&type=template&id=2029ce5c&scoped=true&"
import script from "./TablePOChangeOld.vue?vue&type=script&lang=js&"
export * from "./TablePOChangeOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029ce5c",
  null
  
)

export default component.exports